import React from "react";
import { Button } from "primereact/button";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";

import { useGetBenefitCategoriesQuery } from "../../store/services/benefits";
import { benefitStatusOptions } from "../../utils/constants/benefits-constants";
import { BenefitStatus } from "../../models/benefits";

const featuredOptions: { label: string; value: boolean }[] = [
  { label: "Sí", value: true },
  { label: "No", value: false },
];

interface BenefitPartnerFiltersProps {
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  categoryId?: string;
  setCategoryId: React.Dispatch<React.SetStateAction<string | undefined>>;
  status?: BenefitStatus;
  setStatus: React.Dispatch<React.SetStateAction<BenefitStatus | undefined>>;
  featured?: boolean;
  setFeatured: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  onClearAll: () => void;
}

export const BenefitPartnerFilters = ({
  search,
  setSearch,
  categoryId,
  setCategoryId,
  status,
  setStatus,
  featured,
  setFeatured,
  onClearAll,
}: BenefitPartnerFiltersProps) => {
  // Filtro del listado: usa las categorías del contexto actual (el tenant del
  // selector superior). En scope global el listado muestra todos los tenants.
  const { data: categories, isLoading: isLoadingCategories } =
    useGetBenefitCategoriesQuery({ tenantId: null });

  const categoryOptions = React.useMemo(
    () =>
      (categories ?? []).map((category) => ({
        label: category.name || category.id,
        value: category.id,
      })),
    [categories]
  );

  return (
    <div className="grid mt-3 row-gap-3">
      <div className="col-12 md:col-3">
        <span className="p-float-label w-full">
          <InputText
            id="partnerSearch"
            name="partnerSearch"
            className="w-full"
            value={search}
            onChange={(e) => setSearch(e.currentTarget.value)}
          />
          <label htmlFor="partnerSearch">Nombre o slug</label>
        </span>
      </div>
      <div className="col-12 md:col-3">
        <span className="p-float-label w-full">
          <Dropdown
            id="partnerCategory"
            name="partnerCategory"
            className="w-full"
            value={categoryId ?? null}
            options={categoryOptions}
            optionLabel="label"
            optionValue="value"
            loading={isLoadingCategories}
            onChange={(e: DropdownChangeEvent) =>
              setCategoryId(e.value ?? undefined)
            }
            placeholder="Seleccionar categoría"
            showClear
          />
          <label htmlFor="partnerCategory">Categoría</label>
        </span>
      </div>
      <div className="col-12 md:col-3">
        <span className="p-float-label w-full">
          <Dropdown
            id="partnerStatus"
            name="partnerStatus"
            className="w-full"
            value={status ?? null}
            options={benefitStatusOptions}
            optionLabel="label"
            optionValue="value"
            onChange={(e: DropdownChangeEvent) => setStatus(e.value ?? undefined)}
            placeholder="Seleccionar estado"
            showClear
          />
          <label htmlFor="partnerStatus">Estado</label>
        </span>
      </div>
      <div className="col-12 md:col-3">
        <span className="p-float-label w-full">
          <Dropdown
            id="partnerFeatured"
            name="partnerFeatured"
            className="w-full"
            value={featured ?? null}
            options={featuredOptions}
            optionLabel="label"
            optionValue="value"
            onChange={(e: DropdownChangeEvent) =>
              setFeatured(e.value ?? undefined)
            }
            placeholder="Seleccionar"
            showClear
          />
          <label htmlFor="partnerFeatured">Destacado</label>
        </span>
      </div>
      <div className="col-12 flex flex-wrap justify-content-end align-items-center gap-2">
        <Button
          type="button"
          label="Limpiar filtros"
          icon="pi pi-filter-slash"
          severity="secondary"
          outlined
          size="small"
          onClick={onClearAll}
        />
      </div>
    </div>
  );
};
